'use strict';

var changeRequestModule = angular.module("app.changeRequestModule", []);


changeRequestModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider: ng.ui.IStateProvider, $locationProvider: angular.ILocationProvider) {

        console.log('app.changeRequestModule config...');

        $stateProvider
            .state("changeRequests",
            {
                url: "/changeRequests",
                templateUrl: "assets/templates/changeRequests/changeRequest.html",
                controller: 'changeRequestViewCtrl',
                resolve:{
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Account Information Change Requests"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
    }]);


changeRequestModule.controller('changeRequestBaseCtrl', Patersons.ChangeRequestBaseCtrl);
changeRequestModule.controller('changeRequestViewCtrl', Patersons.ChangeRequestViewCtrl);
